var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9066_18990",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 0H0V64H64V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9066_18990)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9066_18990",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 0H0V64H64V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9066_18990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6778 24.0691L59.5436 17.6566L57.3977 18.535C52.3907 9.11069 42.753 3.27539 32.0236 3.27539C19.3993 3.27539 8.05501 11.7209 4.47854 23.8056C4.32795 24.295 4.60403 24.8221 5.10599 24.9601C5.19383 24.9852 5.28167 24.9978 5.36951 24.9978C5.77108 24.9978 6.13499 24.7343 6.26048 24.3327C9.62362 13.0386 20.215 5.14522 32.0362 5.14522C42.0126 5.14522 50.9852 10.5288 55.6785 19.2629L53.5703 20.1288L58.7028 24.0817L58.6778 24.0691ZM58.9413 39.0778C58.4519 38.9272 57.9373 39.2158 57.7867 39.6927C54.4236 50.9993 43.8323 58.8927 32.0111 58.8927C22.0346 58.8927 13.0621 53.5091 8.36874 44.775L10.477 43.9091L5.34443 39.9562L4.47854 46.3688L6.62441 45.4903C11.6315 54.9146 21.2566 60.7499 31.9985 60.7499C44.6228 60.7499 55.9546 52.3044 59.5436 40.2197C59.6942 39.7303 59.4181 39.2033 58.9287 39.0652L58.9413 39.0778ZM37.0307 26.5036C37.106 26.4409 37.0558 26.4033 36.9052 26.4033C35.437 26.4033 24.4064 29.7287 18.1193 43.8464C15.0574 39.0401 16.0738 32.4142 22.3609 26.5036C30.1162 19.2503 41.7366 18.5978 45.564 18.5978C46.3797 18.5978 46.844 18.6229 46.844 18.6229C46.844 18.6229 47.5217 30.8205 40.6699 40.4707C36.855 45.8793 31.5217 48.7154 26.8283 48.7154C25.586 48.7154 24.3938 48.5272 23.2644 48.1131C21.6832 47.6487 20.4785 46.8205 19.9766 46.2558C19.9766 46.2558 20.7546 44.6746 21.0683 44.0848C22.1852 41.7633 23.5781 39.5797 25.0966 37.5719C26.7028 35.4009 28.0205 34.0331 28.8236 33.2174C33.8683 27.8966 35.4495 27.8966 37.0307 26.5162V26.5036Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.029c6b3e37df06af9ef7fccd45d334e5.svg";
export { ForwardRef as ReactComponent };